export default {
    plaquetteUrl: "https://drive.google.com/file/d/1sqPeFWc4aROlmFoRS2M2230iGnnKhBL2/view"
};
